// Mirror of CssfPdfBusinessSkillsSection.jsx (forced French): bar title + a 30/70
// row whose right column lists every competence as "- name (n)" where n encodes
// the level band (1: <=2, 2: 3-4, 3: >4).

import { AlignmentType, VerticalAlign } from "docx";
import { barSectionTitle, para, run, twoColumnRow } from "../../shared/wordHelpers";
import { CSSF_ACCENT, CSSF_TEXT, FONT_VERDANA } from "../../shared/wordTheme";
import { pxToPt, pxToTwips } from "../../shared/wordUnits";

const DOC_LANG = "fr";

function levelBand( level ) {
    if ( level <= 2 ) {
        return "(1)";
    }
    if ( level <= 4 ) {
        return "(2)";
    }
    return "(3)";
}

export function buildCssfBusinessSkills( { data } ) {
    const { businessSkills } = data;

    const right = [];
    businessSkills.forEach( category => {
        ( category.competences ?? [] ).forEach( competence => {
            const text = `- ${ competence.translations?.[ DOC_LANG ] ?? "" } ${ levelBand( competence.level ) }`;
            right.push( para( run( text, { pt: pxToPt( 9 ), color: CSSF_TEXT, font: FONT_VERDANA } ), { spacing: { after: pxToTwips( 4 ) } } ) );
        } );
    } );

    const left = [ para(
        run( "Compétences techniques", { pt: pxToPt( 9 ), color: CSSF_ACCENT, font: FONT_VERDANA } ),
        { alignment: AlignmentType.RIGHT, spacing: { before: pxToTwips( 4 ), after: 0 } }
    ) ];

    return [
        barSectionTitle( "COMPETENCES", { accent: CSSF_ACCENT, font: FONT_VERDANA } ),
        twoColumnRow( left, right, { leftValign: VerticalAlign.TOP, rightValign: VerticalAlign.TOP, rightMarginLeftPx: 12 } ),
    ];
}
